import { render, staticRenderFns } from "./option-slider.vue?vue&type=template&id=e4652a3a&"
import script from "./option-slider.vue?vue&type=script&lang=js&"
export * from "./option-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports